import Loading from "components/center-loading";
import { Dialog, SelectBox } from 'components/uikit-adapter/index'
import { Component } from "react";
import intl from "react-intl-universal";
import Session from "utils/user-storage";
import {
  save,
  searchAllAccessProfiles,
  searchAllBudgets,
  searchAllCoordinations,
  searchAllCountries,
  searchAllFornecedores,
  searchAllPerfilAcessos,
  searchAllUnidadeNegocio,
  searchStatusTypes,
  searchUserById,
} from "./user-form.service";
import './user-form.css'
import Button from "components/button";
import Input from "components/input";
import OptionGroup from 'components/option-group'
import TipoUsuario from 'models/usuarios/tipo-usuario'
import { UserLanguage } from "pages/master-data/suppliers/supplier-group/supplier-group-form/utils/config-language";
import PropTypes from 'prop-types'
import { isFeatureEnabled } from "utils/feature-flags";
import { formatErrorMessage } from "utils/handle-error";

const TipoPerfilPcpUnidade = 4;
const TipoPerfilFornecedor = 3;
const FEATURE_ROLE_BASED_PERMISSIONS = "FeatureRoleBasedPermissions";

class UserForm extends Component {
  constructor() {
    super();

    this.state = {
      user: {
        Coordination: {
          Id: "",
          Descricao: "",
        },
        Pais: 0,
        Idioma: 0,
        Roles: [],
        SupplierGroups: [],
      },
      roleBasedPermissionsEnabled: false,
      listaPerfilAcessos: [],
      listaPaises: [],
      centers: [],
      budgets: [],
      coordinations: [],
      fornecedores: [],
      requestCount: 0,
      errors: {
        type: "",
      },
      optionsUserType: {
        id: 0,
        optionOne: {
          name: intl.get("UserType.types.Ambev"),
          value: TipoUsuario.Ambev,
          isChecked: true,
          hideOption: false,
        },
        optionTwo: {
          name: intl.get("UserType.types.Supplier"),
          value: TipoUsuario.Fornecedor,
          isChecked: false,
          hideOption: true,
        },
        optionThree: {
          name: intl.get("UserType.types.System"),
          value: TipoUsuario.Sistema,
          isChecked: false,
          hideOption: false,
        },
      },
      typeUserSystem: 1,
    };
  }

  changeOptionsUserType(valueChecked) {
    const { optionsUserType } = this.state;
    const typeUser = Number(valueChecked);

    const _optionsUserType = { ...optionsUserType };
    _optionsUserType.optionOne = { ..._optionsUserType.optionOne, isChecked: _optionsUserType.optionOne.value == valueChecked };
    _optionsUserType.optionTwo = { ..._optionsUserType.optionTwo, isChecked: _optionsUserType.optionTwo.value == valueChecked };
    if (_optionsUserType.optionThree) {
      _optionsUserType.optionThree = { ..._optionsUserType.optionThree, isChecked: _optionsUserType.optionThree.value == valueChecked };
    }

    this.setState({
      typeUserSystem: typeUser,
      optionsUserType: _optionsUserType,
    });
  }

  async componentDidMount() {
    const editMode = this.props.editMode;
    const enabled = await isFeatureEnabled(FEATURE_ROLE_BASED_PERMISSIONS);
    this.setState((prevState) => ({
      roleBasedPermissionsEnabled: enabled,
      optionsUserType: {
        ...prevState.optionsUserType,
        optionTwo: {
          ...prevState.optionsUserType.optionTwo,
          hideOption: !enabled,
        },
      },
    }));

    if (editMode) {
      this.searchUserById();
    }
    this.searchAllBudgets();
    this.searchAllCoordinations();
    this.searchAllCountries();
    this.searchAllPerfilAcessos(enabled);
    this.searchAllUnidadeNegocio();
    this.searchAllFornecedores();
    this.searchStatusTypes();
  }

  handleFetch = (isFetching = true) => {
    this.setState((prevState) => ({
      requestCount: isFetching ? prevState.requestCount + 1 : prevState.requestCount - 1,
    }));
  };

  searchUserById = async () => {
    try {
      this.handleFetch();
      const userId = this.props.idEdit;
      const data = await searchUserById(userId);
      this.proccessData(data);
      this.changeOptionsUserType(data.Perfil);
    } catch (error) {
      console.error(error);
    } finally {
      this.handleFetch(false);
    }
  };

  searchAllBudgets = async () => {
    try {
      this.handleFetch();
      const data = await searchAllBudgets();
      this.setState({ budgets: data });
    } catch (error) {
      this.proccessError(error);
    } finally {
      this.handleFetch(false);
    }
  };

  searchAllCoordinations = async () => {
    try {
      this.handleFetch();
      const data = await searchAllCoordinations();
      this.setState({ coordinations: data });
    } catch (error) {
      this.proccessError(error);
    } finally {
      this.handleFetch(false);
    }
  };

  searchAllCountries = async () => {
    try {
      this.handleFetch();
      const data = await searchAllCountries();
      this.setState({ listaPaises: data });
    } catch (error) {
      this.proccessError(error);
    } finally {
      this.handleFetch(false);
    }
  };

  searchAllPerfilAcessos = async (
    roleBasedPermissionsEnabled = this.state.roleBasedPermissionsEnabled
  ) => {
    try {
      this.handleFetch();
      const listaPerfilAcessos =
        (await (roleBasedPermissionsEnabled
          ? searchAllAccessProfiles()
          : searchAllPerfilAcessos())) || [];
      this.setState({ listaPerfilAcessos });
    } catch (error) {
      this.proccessError(error);
    } finally {
      this.handleFetch(false);
    }
  };

  searchAllUnidadeNegocio = async () => {
    try {
      this.handleFetch();
      const data = await searchAllUnidadeNegocio();
      this.setState({ centers: data });
    } catch (error) {
      this.proccessError(error);
    } finally {
      this.handleFetch(false);
    }
  };

  searchAllFornecedores = async () => {
    try {
      this.handleFetch();
      const data = (await searchAllFornecedores()) || [];
      this.setState({ fornecedores: data });
    } catch (error) {
      this.proccessError(error);
    } finally {
      this.handleFetch(false);
    }
  };

  searchStatusTypes = async () => {
    try {
      this.handleFetch();
      const data = await searchStatusTypes();
      this.setState({ listaStatusUsuario: data });
    } catch (error) {
      this.proccessError(error);
    } finally {
      this.handleFetch(false);
    }
  };

  proccessError = (exception) => {
    try {
      const erro = formatErrorMessage(exception);
      this.props.handleFeedback(erro);
    } catch (e) {
      this.props.handleFeedback(intl.get("feedbacks.serverError"));
    }
  };

  proccessData = (data) => {
    const {
      Id,
      Nome,
      Email,
      Perfil,
      PerfilAcesso,
      Roles,
      Pais,
      Idioma,
      Centros,
      Carteiras,
      SupplierGroups,
      IdCoordenacao,
      NomeCoordenacao,
      Status,
    } = data;

    this.setState({
      user: {
        Id: Id,
        Nome: Nome,
        Email: Email,
        Perfil: Perfil,
        PerfilAcesso: PerfilAcesso,
        Roles: Roles ?? [],
        Pais: Pais,
        Idioma: Idioma,
        Centers: Centros,
        Status: Status,
        Budget: Carteiras,
        SupplierGroups: SupplierGroups ?? [],
        Coordination: {
          Id: IdCoordenacao,
          Descricao: NomeCoordenacao,
        },
      },
    });
  };

  changeValue = (event) => {
    const prop = event.currentTarget.name;
    const value = event.currentTarget.value;

    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        [prop]: value,
      },
    }));
  };

  onCloseClick = () => {
    this.props.handleClose();
  };

  updateBudgetSelectValue = (event) => {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        Budget: [...event],
      },
    }));
  };

  updateCoordinationSelectValue = (value) => {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        Coordination: {
          ...prevState.user.Coordination,
          Id: value,
        },
      },
    }));
  };

  updatePerfilAcessosSelectValue(value) {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        PerfilAcesso: value,
      },
    }));
  }

  updateRolesSelectValue = (selected) => {
    const Roles = Array.isArray(selected) ? selected.map((x) => x.Id) : [];
    const hasFornecedor = Roles.includes(TipoPerfilFornecedor);
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        Roles,
        SupplierGroups: hasFornecedor ? prevState.user.SupplierGroups : [],
      },
    }));
  };

  updateSupplierGroupsSelectValue = (selected) => {
    const SupplierGroups = Array.isArray(selected) ? selected.map((x) => x.Id) : [];
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        SupplierGroups,
      },
    }));
  };

  updatePaisSelectValue(value) {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        Pais: value,
      },
    }));
  }

  updateIdiomaSelectValue(value) {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        Idioma: value,
      },
    }));
  }

  updateCentersSelectValue = (event) => {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        Centers: [...event],
      },
    }));
  };

  updateSelectValue = (prop, value) => {
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        [prop]: value,
      },
    }));
  };

  save = async () => {
    const editMode = this.props.editMode;
    const user = Session.get();
    const usuario = this.state.user;
    const enabled = this.state.roleBasedPermissionsEnabled;

    const model = {
      Id: usuario.Id ? usuario.Id : 0,
      Nome: usuario.Nome,
      Email: Array.isArray(usuario.Email) ? usuario.Email : [usuario.Email],
      PerfilAcesso: enabled ? null : usuario.PerfilAcesso,
      Roles: enabled ? usuario.Roles || [] : [usuario.PerfilAcesso],
      Pais: usuario.Pais,
      Idioma: usuario.Idioma,
      Centros: usuario.Centers ? usuario.Centers.map((x) => ({ Id: x.Id })) : null,
      Carteiras: usuario.Budget ? usuario.Budget.map((x) => ({ Id: x.Id })) : null,
      SupplierGroups: usuario.SupplierGroups || null,
      IdCoordenacao: usuario.Coordination.Id,
      Status: usuario.Status,
      Perfil: this.state.typeUserSystem,
    };

    try {
      if (this.validateForm(model)) {
        this.handleFetch();
        await save(user.Id, model);

        localStorage.removeItem("settings");

        this.props.handleRefresh();
        this.props.handleFeedback(
          `${intl.get("feedbacks.register")} ${!editMode ? intl.get("feedbacks.saved") : intl.get("feedbacks.updated")} ${intl.get("feedbacks.withSuccess")}`
        );
        this.props.handleClose();
      }
    } catch (error) {
      this.proccessError(error);
    } finally {
      this.handleFetch(false);
    }
  };

  validateForm = (model) => {
    const enabled = this.state.roleBasedPermissionsEnabled;
    const hasPcpUnidade = enabled
      ? (model.Roles || []).includes(TipoPerfilPcpUnidade)
      : model.PerfilAcesso === TipoPerfilPcpUnidade;
    const hasFornecedor = enabled
      ? (model.Roles || []).includes(TipoPerfilFornecedor)
      : model.PerfilAcesso === TipoPerfilFornecedor;
    if (!model.Nome) {
      this.validateFields(intl.get("feedbacks.messageUserForm4"));
      return false;
    }
    if (!model.Email[0]) {
      this.validateFields(intl.get("feedbacks.messageUserForm5"));
      return false;
    }
    if (!model.Pais) {
      this.validateFields(intl.get("feedbacks.messageUserForm6"));
      return false;
    }
    if (!model.Idioma) {
      this.validateFields(intl.get("feedbacks.messageUserForm7"));
      return false;
    }
    if (enabled && (!model.Roles || model.Roles.length === 0)) {
      this.validateFields(intl.get("feedbacks.messageUserFormAccessProfileRequired"));
      return false;
    }
    if (hasPcpUnidade && (!model.Centros || model.Centros.length === 0)) {
      this.validateFields(intl.get("feedbacks.messageUserForm8"));
      return false;
    }
    if (hasFornecedor && !model.SupplierGroups?.length) {
      this.validateFields(intl.get("feedbacks.messageUserFormSupplierGroupRequired"));
      return false;
    }
    const isSomenteFornecedor = enabled && (model.Roles || []).length === 1 && (model.Roles || []).includes(TipoPerfilFornecedor);
    if (isSomenteFornecedor && model.Perfil !== TipoUsuario.Fornecedor) {
      this.validateFields(intl.get("feedbacks.messageUserFormFornecedorRadioRequired"));
      return false;
    }
    return this.validateEmailFormat(model);
  };

  validateEmailFormat = (model) => {
    const regexEmail = /\S+@\S+\.\S+/;
    const regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    if (model.Perfil != TipoUsuario.Sistema && !regexEmail.test(model.Email)) {
      this.validateFields(intl.get("feedbacks.messageUserForm10"));
      return false;
    }
    if (model.Perfil == TipoUsuario.Sistema && !regexGuid.test(model.Email)) {
      this.validateFields(intl.get("feedbacks.messageUserForm11"));
      return false;
    }
    return true;
  };

  validateFields = (message) => {
    this.handleFetch(false);
    this.props.handleFeedback(message);
  };

  render() {
    const {
      user,
      requestCount,
      budgets,
      listaPerfilAcessos,
      centers,
      listaStatusUsuario,
      coordinations,
      listaPaises,
      fornecedores,
      roleBasedPermissionsEnabled,
    } = this.state;
    const { open, editMode, profileAdminOrMasterData } = this.props;

    const hasFornecedorRole = roleBasedPermissionsEnabled
      ? (user.Roles || []).includes(TipoPerfilFornecedor)
      : user.PerfilAcesso === TipoPerfilFornecedor;

    return (
      <div>
        <Loading isLoading={requestCount > 0} />

        <Dialog
          title={
            editMode
              ? intl.get("master-data.coordinationsAndUsers.users.actions.editUser")
              : intl.get("master-data.coordinationsAndUsers.users.actions.newUser")
          }
          contentStyle={{ width: "600px" }}
          autoScrollBodyContent={true}
          open={open}
        >
          <OptionGroup
            title={intl.get("UserType.title")}
            options={this.state.optionsUserType}
            disabled={false}
            handleSelect={(ev) => this.changeOptionsUserType(ev.currentTarget.value)}
          />

          <div className="line-1-columns">
            <Input
              required
              name="Nome"
              label={intl.get("master-data.general-configuration.name")}
              value={user.Nome}
              onChange={this.changeValue}
              disabled={!profileAdminOrMasterData}
            />
          </div>

          <div className="line-1-columns">
            <Input
              required
              name="Email"
              label={intl.get("commons.email")}
              value={user.Email}
              onChange={this.changeValue}
              disabled={!profileAdminOrMasterData}
            />
          </div>

          {profileAdminOrMasterData && !roleBasedPermissionsEnabled && (
            <SelectBox
              required
              label={intl.get("commons.accessProfile")}
              placeholder={intl.get("commons.accessProfile")}
              valueKey="Id"
              labelKey="Description"
              value={user.PerfilAcesso}
              options={listaPerfilAcessos}
              onChange={(value) =>
                this.updatePerfilAcessosSelectValue(value === null ? "" : value.Id)
              }
              searchable
              openOnFocus
              clearable
            />
          )}

          {profileAdminOrMasterData && roleBasedPermissionsEnabled && (
            <SelectBox
              required
              label={intl.get("commons.accessProfile")}
              placeholder={intl.get("commons.accessProfile")}
              valueKey="Id"
              labelKey="Description"
              value={(listaPerfilAcessos || []).filter((p) => (user.Roles || []).includes(p.Id))}
              options={(listaPerfilAcessos || []).filter((p) => !(user.Roles || []).includes(p.Id))}
              onChange={this.updateRolesSelectValue}
              searchable
              openOnFocus
              multi
            />
          )}

          <SelectBox
            required
            className="country__selectbox"
            label={intl.get("commons.country")}
            placeholder={intl.get("commons.country")}
            valueKey="Key"
            labelKey="Value"
            value={user.Pais}
            options={listaPaises}
            onChange={(value) => this.updatePaisSelectValue(value === null ? "" : value.Key)}
            searchable
            openOnFocus
            clearable
          />

          <SelectBox
            required
            className="language__selectbox"
            label={intl.get("commons.language")}
            placeholder={intl.get("commons.language")}
            valueKey="Key"
            labelKey="Value"
            value={user.Idioma}
            options={UserLanguage}
            onChange={(value) => this.updateIdiomaSelectValue(value === null ? "" : value.Key)}
            searchable
            openOnFocus
            clearable
          />

          <SelectBox
            required
            label={intl.get("commons.unit")}
            placeholder={intl.get("commons.unit")}
            valueKey="Id"
            labelKey="Nome"
            value={user.Centers}
            options={centers}
            onChange={this.updateCentersSelectValue}
            searchable
            openOnFocus
            multi
          />

          {roleBasedPermissionsEnabled && hasFornecedorRole && (
            <SelectBox
              required
              label={intl.get("commons.supplier")}
              placeholder={intl.get("commons.supplier")}
              valueKey="Id"
              labelKey="Description"
              value={(fornecedores || []).filter((f) => (user.SupplierGroups || []).includes(f.Id))}
              options={fornecedores}
              onChange={this.updateSupplierGroupsSelectValue}
              disabled={!profileAdminOrMasterData}
              searchable
              openOnFocus
              multi
            />
          )}

          <SelectBox
            required
            label={intl.get("master-data.general-configuration.coordination")}
            placeholder={intl.get("master-data.general-configuration.coordination")}
            valueKey="Id"
            labelKey="Description"
            value={user.Coordination.Id}
            options={coordinations}
            onChange={(value) => this.updateCoordinationSelectValue(value === null ? "" : value.Id)}
            disabled={!profileAdminOrMasterData}
            searchable
            openOnFocus
            clearable
          />

          <SelectBox
            required
            label={intl.get("commons.wallet")}
            placeholder={intl.get("commons.wallet")}
            valueKey="Id"
            labelKey="Description"
            value={user.Budget}
            options={budgets}
            onChange={this.updateBudgetSelectValue}
            disabled={!profileAdminOrMasterData}
            searchable
            openOnFocus
            multi
          />

          <SelectBox
            required
            label={intl.get("commons.status")}
            placeholder={intl.get("commons.status")}
            name="Status"
            value={user.Status}
            valueKey="Key"
            labelKey="Value"
            onChange={(value) => this.updateSelectValue("Status", value.Key)}
            openOnFocus={true}
            options={listaStatusUsuario}
            width="100%"
            disabled={!profileAdminOrMasterData}
            className="select-status"
          />

          <div className="footer-dialog-buttons">
            <div className="line-buttons">
              <Button
                buttonType="default"
                value={intl.get("geral.buttonsDefault.cancel")}
                onClick={this.onCloseClick}
                className="button"
              />
              {profileAdminOrMasterData && (
                <Button
                  buttonType="primary"
                  value={intl.get("geral.buttonsDefault.save")}
                  className="button btn-save-user"
                  onClick={this.save}
                  disabled={requestCount > 0}
                />
              )}
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

UserForm.propTypes = {
  editMode: PropTypes.bool,
  handleClose: PropTypes.func,
  handleFeedback: PropTypes.func,
  handleRefresh: PropTypes.func,
  idEdit: PropTypes.number,
  open: PropTypes.bool,
  profileAdminOrMasterData: PropTypes.bool
}

export default UserForm
